import { compose, mdsWidget } from 'dojo/_base/declare';
import _Control from './_Control';

class _Switchable extends compose(_Control) {
    [key: string]: any;

    editMode = false;
    value: any = null;
    part: any = null;
    _initialValueSet = false;

    onValueChange() {

    }

    _getValueAttr() {
        return this.value;
    }

    _setValueAttr(value: any, bCallOnChange: any) {
        //console.log("switchable setvalue", value, bCallOnChange);
        if (value == this.value) { bCallOnChange = false; }
        this.value = value;

        if (typeof (bCallOnChange) == "undefined") {
            bCallOnChange = true;
        }

        if (bCallOnChange === true && this._initialValueSet == true) {
            this.onValueChange();
            this.emit("change", value);
        }

        if (this._initialValueSet == false) {
            this._initialValueSet = true;
        }
    }

    _setEditModeAttr(value: any) {

        this.editMode = value;

        this.EditModeChanged();
    }

    _getEditModeAttr() {
        return this.editMode;
    }

    EditModeChanged() {

        this.emit("editModeChanged", this.editMode);
    }

    postMixInProperties(): void {
        super.postMixInProperties.apply(this, arguments as any);
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        (this.set as any)("value", this.value, false);

        // initialer aufruf
        this.EditModeChanged();
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }

    _setupSubscriptions(): void {
        super._setupSubscriptions.apply(this, arguments as any);
    }

    destroy(): void {
        super.destroy.apply(this, arguments as any);
    }
}

export default mdsWidget(_Switchable);
